import { CALL_API } from '../middleware/api'

import { updatePermissions } from './permissions.js';

export const MAIN_SETTINGS_REQUEST = 'MAIN_SETTINGS_REQUEST'
export const MAIN_SETTINGS_SUCCESS = 'MAIN_SETTINGS_SUCCESS'
export const MAIN_SETTINGS_FAILURE = 'MAIN_SETTINGS_FAILURE'

export const COURSES_INFO_REQUEST = 'COURSES_INFO_REQUEST'
export const COURSES_INFO_SUCCESS = 'COURSES_INFO_SUCCESS'
export const COURSES_INFO_FAILURE = 'COURSES_INFO_FAILURE'

export const MEMBERS_INFO_REQUEST = 'MEMBERS_INFO_REQUEST'
export const MEMBERS_INFO_SUCCESS = 'MEMBERS_INFO_SUCCESS'
export const MEMBERS_INFO_FAILURE = 'MEMBERS_INFO_FAILURE'

export const GENERAL_SETTINGS_REQUEST = 'GENERAL_SETTINGS_REQUEST'
export const GENERAL_SETTINGS_SUCCESS = 'GENERAL_SETTINGS_SUCCESS'
export const GENERAL_SETTINGS_FAILURE = 'GENERAL_SETTINGS_FAILURE'

export const CONTACT_SETTINGS_REQUEST = 'CONTACT_SETTINGS_REQUEST'
export const CONTACT_SETTINGS_SUCCESS = 'CONTACT_SETTINGS_SUCCESS'
export const CONTACT_SETTINGS_FAILURE = 'CONTACT_SETTINGS_FAILURE'

export const INVOICES_SETTINGS_REQUEST = 'INVOICES_SETTINGS_REQUEST'
export const INVOICES_SETTINGS_SUCCESS = 'INVOICES_SETTINGS_SUCCESS'
export const INVOICES_SETTINGS_FAILURE = 'INVOICES_SETTINGS_FAILURE'

export const MEMBERS_SETTINGS_REQUEST = 'MEMBERS_SETTINGS_REQUEST'
export const MEMBERS_SETTINGS_SUCCESS = 'MEMBERS_SETTINGS_SUCCESS'
export const MEMBERS_SETTINGS_FAILURE = 'MEMBERS_SETTINGS_FAILURE'

export const MEMBERSHIP_TYPES_REQUEST = 'MEMBERSHIP_TYPES_REQUEST'
export const MEMBERSHIP_TYPES_SUCCESS = 'MEMBERSHIP_TYPES_SUCCESS'
export const MEMBERSHIP_TYPES_FAILURE = 'MEMBERSHIP_TYPES_FAILURE'

export const SUBSCRIPTIONS_REQUEST = 'SUBSCRIPTIONS_REQUEST'
export const SUBSCRIPTIONS_SUCCESS = 'SUBSCRIPTIONS_SUCCESS'
export const SUBSCRIPTIONS_FAILURE = 'SUBSCRIPTIONS_FAILURE'

export const COURSES_SETTINGS_REQUEST = 'COURSES_SETTINGS_REQUEST'
export const COURSES_SETTINGS_SUCCESS = 'COURSES_SETTINGS_SUCCESS'
export const COURSES_SETTINGS_FAILURE = 'COURSES_SETTINGS_FAILURE'

export const TUTORS_REQUEST = 'TUTORS_REQUEST'
export const TUTORS_SUCCESS = 'TUTORS_SUCCESS'
export const TUTORS_FAILURE = 'TUTORS_FAILURE'

export const LABELS_COURSES_REQUEST = 'LABELS_COURSES_REQUEST'
export const LABELS_COURSES_SUCCESS = 'LABELS_COURSES_SUCCESS'
export const LABELS_COURSES_FAILURE = 'LABELS_COURSES_FAILURE'

export const LABELS_MEMBERS_REQUEST = 'LABELS_MEMBERS_REQUEST'
export const LABELS_MEMBERS_SUCCESS = 'LABELS_MEMBERS_SUCCESS'
export const LABELS_MEMBERS_FAILURE = 'LABELS_MEMBERS_FAILURE'

const mainSettings = ['general', 'invoices', 'courses', 'enrolments', 'members', 'labels_courses', 'labels_members']; 

const fetchSettings = (mappedSetting) => ({
	[CALL_API]: mappedSetting
})

export const loadCoursesInfo = (infoType) => (dispatch, getState) => {
	const now = Math.floor(Date.now() / 1000) // JS dates are in milliseconds!

	switch(infoType){
		case 'general':
			const cInfo = getState().settings.request_courses_info;
			if(cInfo.fetching || cInfo.expires >= now){
				return null;
			}
			
			const req = {
				types: [COURSES_INFO_REQUEST, COURSES_INFO_SUCCESS, COURSES_INFO_FAILURE],
				endpoint: '/courses_info/',
				method: 'GET',
				params: {},
				bad_response: 'Error fetching courses settings from U-MAS database'
			};
			return dispatch(fetchSettings(req))
			
		case 'tutors':
			const t = getState().settings.tutors;
			if(t && t.expires >= now){
				return null;
			}
		
			const user = getState().user;
			const sTutors = {
				types: [TUTORS_REQUEST, TUTORS_SUCCESS, TUTORS_FAILURE],
				endpoint: '/tutors/',
				method: user.member_no > 0 ? 'POST' : 'GET',
				params: {},
				bad_response: 'Error fetching tutors list from U-MAS database'
			};
			return dispatch(fetchSettings(sTutors))
			
		default:
			return null;
	}
}

export const loadMembersInfo = (infoType) => (dispatch, getState) => {
	const now = Math.floor(Date.now() / 1000) // JS dates are in milliseconds!
	const mInfo = getState().settings.request_members_info;
	switch(infoType){
		case 'general':
			if(mInfo.fetching || mInfo.expires >= now){
				return null;
			}
			const req = {
				types: [MEMBERS_INFO_REQUEST, MEMBERS_INFO_SUCCESS, MEMBERS_INFO_FAILURE],
				endpoint: '/members_info/',
				method: 'GET',
				params: {},
				bad_response: 'Error fetching memberships settings from U-MAS database'
			};
			return dispatch(fetchSettings(req))
			
		case 'membership_types':
			const me = getState().settings.membership_types.expires;
			if(mInfo.fetching || me >= now){
				return null;
			}
			const sMemTypes = {
				types: [MEMBERSHIP_TYPES_REQUEST, MEMBERSHIP_TYPES_SUCCESS, MEMBERSHIP_TYPES_FAILURE],
				endpoint: '/memberships/',
				method: 'GET',
				params: {},
				bad_response: 'Error fetching membership types from U-MAS database'
			};
			return dispatch(fetchSettings(sMemTypes))
			
		case 'subscriptions':
			return dispatch(fetchSettings({
				types: [SUBSCRIPTIONS_REQUEST, SUBSCRIPTIONS_SUCCESS, SUBSCRIPTIONS_FAILURE],
				endpoint: '/subscriptions/',
				method: 'GET',
				params: {},
				bad_response: 'Error fetching membership subscriptions from U-MAS database'
			}))
		default:
			return null;
	}
	
}

export const loadSettings = (settingsType) => (dispatch, getState) => {
	
	const fetchingMainSettings = getState().settings.fetching_main_settings;
	if(fetchingMainSettings && mainSettings.includes(settingsType)){
		return null;
	}
	const currentSettings = getState().settings[settingsType];
	const now = Math.floor(Date.now() / 1000) // JS dates are in milliseconds!
	if (currentSettings && currentSettings.expires >= now) {
		return null
	}
	
	switch(settingsType){
		case 'all':
			const sAll = {
				types: [MAIN_SETTINGS_REQUEST, MAIN_SETTINGS_SUCCESS, MAIN_SETTINGS_FAILURE],
				endpoint: '/settings/',
				method: 'GET',
				params: {
					settings: 'all'
				},
				bad_response: 'Error fetching settings from U-MAS database'
			};
			return dispatch(fetchSettings(sAll)).then(result => {
				dispatch(updatePermissions());
			});
		case 'general':
			const sGeneral = {
				types: [GENERAL_SETTINGS_REQUEST, GENERAL_SETTINGS_SUCCESS, GENERAL_SETTINGS_FAILURE],
				endpoint: '/settings/',
				method: 'GET',
				params: {
					settings: 'general'
				},
				bad_response: 'Error fetching general settings from U-MAS database'
			};
			return dispatch(fetchSettings(sGeneral)).then(result => {
				dispatch(updatePermissions());
			});
		case 'contact':
			const sContact = {
				types: [CONTACT_SETTINGS_REQUEST, CONTACT_SETTINGS_SUCCESS, CONTACT_SETTINGS_FAILURE],
				endpoint: '/contact/',
				method: 'GET',
				params: {},
				bad_response: 'Error fetching contact details from U-MAS database'
			};
			return dispatch(fetchSettings(sContact))
		case 'invoices':
			const sInvoices = {
				types: [INVOICES_SETTINGS_REQUEST, INVOICES_SETTINGS_SUCCESS, INVOICES_SETTINGS_FAILURE],
				endpoint: '/settings/',
				method: 'GET',
				params: {
					settings: 'invoices'
				},
				bad_response: 'Error fetching invoice settings from U-MAS database'
			};
			return dispatch(fetchSettings(sInvoices))
		case 'members':
			const sMembers = {
				types: [MEMBERS_SETTINGS_REQUEST, MEMBERS_SETTINGS_SUCCESS, MEMBERS_SETTINGS_FAILURE],
				endpoint: '/settings/',
				method: 'GET',
				params: {
					settings: 'members'
				},
				bad_response: 'Error fetching members settings from U-MAS database'
			};
			return dispatch(fetchSettings(sMembers))
		
		case 'courses':
			const sCourses = {
				types: [COURSES_SETTINGS_REQUEST, COURSES_SETTINGS_SUCCESS, COURSES_SETTINGS_FAILURE],
				endpoint: '/settings/',
				method: 'GET',
				params: {
					settings: 'courses'
				},
				bad_response: 'Error fetching courses settings from U-MAS database'
			};
			return dispatch(fetchSettings(sCourses))

		case 'labels_courses':
			const sLabelsCourses = {
				types: [LABELS_COURSES_REQUEST, LABELS_COURSES_SUCCESS, LABELS_COURSES_FAILURE],
				endpoint: '/labels/',
				method: 'GET',
				params: {
					labels: 'courses'
				},
				bad_response: 'Error fetching course labels from U-MAS database'
			};
			return dispatch(fetchSettings(sLabelsCourses))
		case 'labels_members':
			const sLabelsMembers = {
				types: [LABELS_MEMBERS_REQUEST, LABELS_MEMBERS_SUCCESS, LABELS_MEMBERS_FAILURE],
				endpoint: '/labels/',
				method: 'GET',
				params: {
					labels: 'members'
				},
				bad_response: 'Error fetching member labels from U-MAS database'
			};
			return dispatch(fetchSettings(sLabelsMembers))
		default: 
			return null 
	}

}